import React from "react";
import { Button } from "antd";
import { ButtonProps } from "antd/lib/button";
import "./Button.Component.less";
import { ToolTipC } from "..";
import { TooltipProps } from "antd/lib/tooltip";
interface ButtonComponentProps extends ButtonProps {
  types?: "next" | "skip" | "previous" | "next & continue" | "primaryGradient";
  disabledMessage?: string;
  disabledMessageProps?: TooltipProps;
}

const ButtonComponent = (props: ButtonComponentProps) => {
  const { types, className, disabledMessage, disabledMessageProps } = props;
  const component = (cProps?: ButtonComponentProps) => {
    if (disabledMessage && disabledMessage.length) {
      return (
        <ToolTipC
          title={disabledMessage}
          {...disabledMessageProps}
          style={{ background: "transparent" }}
        >
          <Button {...cProps} />
        </ToolTipC>
      );
    }
    return <Button type="primary" {...cProps} />;
  };

  switch (types) {
    case "next & continue":
      return component({
        children: "Next & Continue",
        ...props,
        className: ` ${className} ButtonComponent_next_continue `,
      });
    case "skip":
      return component({
        children: "Skip",
        ...props,
        className: ` ${className} ButtonComponent_skip `,
      });
    case "previous":
      return component({
        children: "Previous",
        ...props,
        className: ` ${className} ButtonComponent_previous `,
      });
    case "next":
      return component({
        children: "Next",
        ...props,
        className: `${className} ButtonComponent_next `,
      });
    case "primaryGradient":
      return component({
        ...props,
        className: `${className} primary-gradient-color`,
      });
  }

  return component({ ...props });
};

export default ButtonComponent;
